import httpClient from './httpClient';

const API_BASE_URL = '/informacion-general';

export const informacionGeneralService = {
    // Obtener información general actual
    obtenerInformacionActual: async () => {
        try {
            const response = await httpClient.get(API_BASE_URL);
            return response.data;
        } catch (error) {
            console.error('Error al obtener información general:', error);
            throw error;
        }
    },

    // Actualizar sueldo mínimo
    actualizarSueldoMinimo: async (monto) => {
        try {
            const response = await httpClient.put(`${API_BASE_URL}/sueldo-minimo`, {
                monto: parseFloat(monto)
            });
            return response.data;
        } catch (error) {
            console.error('Error al actualizar sueldo mínimo:', error);
            throw error;
        }
    },

    // Actualizar UIT
    actualizarUit: async (monto) => {
        try {
            const response = await httpClient.put(`${API_BASE_URL}/uit`, {
                monto: parseFloat(monto)
            });
            return response.data;
        } catch (error) {
            console.error('Error al actualizar UIT:', error);
            throw error;
        }
    },

    // Obtener historial de sueldo mínimo
    obtenerHistorialSueldoMinimo: async () => {
        try {
            const response = await httpClient.get(`${API_BASE_URL}/sueldo-minimo/historial`);
            return response.data;
        } catch (error) {
            console.error('Error al obtener historial de sueldo mínimo:', error);
            throw error;
        }
    },

    // Obtener historial de UIT
    obtenerHistorialUit: async () => {
        try {
            const response = await httpClient.get(`${API_BASE_URL}/uit/historial`);
            return response.data;
        } catch (error) {
            console.error('Error al obtener historial de UIT:', error);
            throw error;
        }
    }
};

export default informacionGeneralService; 